import React from 'react';
import isNil from 'lodash/isNil';
import { IDateInput } from '../../../../redux/slices/oldBuilder/date/types';
import { SvgIcon } from '../../../Icon';
import DatePickerDisplay from './DatePickerDisplay';
import { datePickerFromDateInput } from '../utils';
import { MaybeNil } from '../../../../utils/interfaces';
import BorderedDropdownLabel from '../../../Dropdown/BorderedDropdownLabel';

interface IProps {
  dateInput: MaybeNil<IDateInput>;
}

const DateRangeDisplay = ({ dateInput }: IProps) => (
  <BorderedDropdownLabel>
    {!isNil(dateInput) ? (
      <DatePickerDisplay datePicker={datePickerFromDateInput(dateInput)} />
    ) : (
      <SvgIcon
        name="date-range-picker"
        customFill="currentColor"
        width={16}
        height={16}
      />
    )}
  </BorderedDropdownLabel>
);

export default DateRangeDisplay;
